
 import * as React from 'react';
 import {createComponent, EventName} from '@lit/react';
 
 import {ObcAdviceFloatingItem as ObcAdviceFloatingItemElement} from '@oicl/openbridge-webcomponents/dist/components/advice-floating-item/advice-floating-item.js';
 
 
 

 
 export const ObcAdviceFloatingItem = createComponent({
   react: React,
   tagName: 'obc-advice-floating-item',
   elementClass: ObcAdviceFloatingItemElement,
   events: {
     
     onActionClick: 'action-click' as EventName<CustomEvent<void>>,
     onAction2Click: 'action2-click' as EventName<CustomEvent<void>>,
     onDismissClick: 'dismiss-click' as EventName<CustomEvent<void>>,
   }
  });
 
 